import {CHANGE_CLIENT, LOGOUT} from '../mutations/available'
import api from '@/api'
const { getBaseLoginAppURL } = require('../../helpers/baseurl')

export const changeClient = async ({commit, dispatch}, clientId) => {
  commit(CHANGE_CLIENT, clientId)
  dispatch('resetPage')
  dispatch('loadCases')
  dispatch('caseCreationOrdersResetPage')
  dispatch('caseCreationOrdersLoad')
}

export const logout = async({commit}) => {
  try {
    await api.logout()
    commit(LOGOUT)

    window.location = getBaseLoginAppURL()
  } catch (e) {
    console.log(e)
  }
}
